import _import from './config'
export default {
    path: 'finance',
    component: {
        template: '<router-view :key="$route.fullPath"/>'
    },
    name: 'finance',
    redirect: '/finance/orderList',
    children: [
        {
            path: 'orderList',
            component: _import('finance/orderList'),
            name: 'orderList',
            meta: {
                auth: true
            }
        }, {
            path: 'orderRateList',
            component: _import('finance/orderRateList'),
            name: 'orderRateList',
            meta: {
                auth: true
            }
        }, {
            path: 'balancetransfer',
            component: _import('finance/balancetransfer'),
            name: 'balancetransfer',
            meta: {
                auth: true
            }
        }, {
            path: 'financeincome',
            component: _import('finance/financeincome'),
            name: 'financeincome',
            meta: {
                auth: true
            }
        }, {
            path: 'refundorderList',
            component: _import('finance/refundorderList'),
            name: 'refundorderList',
            meta: {
                auth: true
            }
        }, {
            path: 'mission',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'mission',
            redirect: '/finance/mission/group',
            children: [
                {
                    path: 'group',
                    component: _import('finance/mission/groupmission'),
                    name: 'group',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'branch',
                    component: _import('finance/mission/branchmission'),
                    name: 'branch',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'campus',
                    component: _import('finance/mission/campusmission'),
                    name: 'campus',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'department',
                    component: _import('finance/mission/departmentmission'),
                    name: 'department',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'subjectmission',
                    component: _import('finance/mission/subgroupmission'),
                    name: 'subjectmission',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'studyadmintask',
                    component: _import('finance/mission/studyAdminMission'),
                    name: 'studyadmintask',
                    meta: {
                        auth: true
                    }
                }
            ]
        }, {
            path: 'costbreak',
            component: {
                template: '<router-view :key="$route.fullPath"/>'
            },
            name: 'costbreak',
            redirect: '/finance/costbreak/refundfee',
            children: [
                {
                    path: 'refundfee',
                    component: _import('finance/costbreak/refundFee'),
                    name: 'refundfee',
                    meta: {
                        auth: true
                    }
                }, {
                    path: 'renewalfee',
                    component: _import('finance/costbreak/renewalFee'),
                    name: 'renewalfee',
                    meta: {
                        auth: true
                    }
                }
            ]
        }, {
            path: 'selfinvitiebuy',
            component: _import('finance/selfinvitebuy'),
            name: 'selfinvitebuy',
            meta: {
                auth: true
            }
        }, {
            path: 'selfinvitierefund',
            component: _import('finance/selfinviterefund'),
            name: 'selfinviterefund',
            meta: {
                auth: true
            }
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/finance.js